import React from 'react';
import { EU_STATUS_LABELS, getStatusColor } from '../utils/euStatusUtils';
import { getTrendArrow, getTrendArrowClass, getTrendLegendLabels } from '../utils/euTrendUtils';
import '../utils/sharedStyles.css';
import './HomeAssessmentLegend.css';

const EU_STATUS_LEGEND = [
  EU_STATUS_LABELS[5],
  EU_STATUS_LABELS[4],
  EU_STATUS_LABELS[3],
  EU_STATUS_LABELS[2],
  EU_STATUS_LABELS[1],
  EU_STATUS_LABELS[0],
];

/**
 * Home assessment key.
 * EU: STATUS (quintiles) + PROGRESS (trend). UN: PROGRESS only (CP-1).
 */
const HomeAssessmentLegend = ({ goalType, copy = {} }) => {
  const isEu = goalType !== 'un';
  const heading = isEu
    ? copy.legendHeading || 'SDG Progress & Status Assessment'
    : copy.legendHeading || 'SDG Progress';

  const statusBlurb =
    copy.statusAssessmentBlurb ||
    'STATUS: Where Kosovo sits among EU-27 comparison countries (benchmark quintiles)';
  const progressBlurb =
    copy.progressBlurb ||
    'PROGRESS: Direction and pace of progress toward each SDG target';

  return (
    <section className="home-legend" aria-labelledby="home-legend-heading">
      <h2 id="home-legend-heading" className="home-legend__heading">
        {heading}
      </h2>

      {isEu ? (
        <div className="home-legend__block">
          <p className="home-legend__block-title">{statusBlurb}</p>
          <ul className="home-legend__items">
            {EU_STATUS_LEGEND.map((label) => (
              <li key={label} className="home-legend__item">
                <span
                  className="home-legend__dot"
                  style={{ backgroundColor: getStatusColor(label) }}
                  aria-hidden="true"
                />
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      <div className="home-legend__block">
        <p className="home-legend__block-title">{progressBlurb}</p>
        <ul className="home-legend__items">
          {getTrendLegendLabels(goalType).map((label) => {
            const isInsufficient = label === 'Insufficient data';
            const { arrow } = isInsufficient ? { arrow: '—' } : getTrendArrow(label);
            const trendClass = isInsufficient
              ? 'trend-arrow-default'
              : getTrendArrowClass(label);
            return (
              <li key={label} className="home-legend__item">
                <span
                  className={`home-legend__arrow trend-arrow trend-arrow-large ${trendClass}`}
                  aria-hidden="true"
                >
                  {arrow}
                </span>
                <span>{label}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default HomeAssessmentLegend;
